import { MileageUnit, VehicleBasicInfo } from "@/src/types/types";

import { atomWithStorage } from "jotai/utils";

// Step 2 / 12
export const vehicleBasicInfoStateAtom = atomWithStorage<{
  mileage: number | null;
  mileageUnit?: MileageUnit;
  vehicleBasicInfo: VehicleBasicInfo | null;
}>(
  "vehicleBasicInfoStateAtom",
  {
    mileage: null,
    vehicleBasicInfo: null,
    mileageUnit: MileageUnit.KM
  },
  undefined,
  { getOnInit: true }
);
